import { UIElement } from '../ui-element';
import { Component } from '../../decorators/component.decorator';
import styles from './ui-layout-head.css';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UILayoutHead
 * @element ui-layout-head
 * @classdesc Represents a class for <code>ui-layout-head</code> element.
 * @example
 * <ui-layout-head>
 *     <h1>Page title</h1>
 * </ui-layout-head>
 */
@Component({ tag: 'ui-layout-head', styles })
export class UILayoutHead extends UIElement {
    /**
     * @inheritDoc
     */
    override render(): void {}
}
